import { STAGE_LABELS, StageStatus, Step, stageReading, stageStatus } from '../recognition-steps';

// Contraste (WCAG 1.4.3): o design usa branco a 80% sobre o azul claro do cabeçalho (3,3:1) e
// azul sobre amarelo (4,44:1). Aqui a pílula ativa leva o azul-escuro (8,13:1) e as demais
// ficam sobre o azul-escuro com texto branco (8,94:1).
const PILL_CLASSES: Record<StageStatus, string> = {
  current: 'bg-brand-yellow text-brand-blue-dark',
  done: 'bg-brand-blue-dark text-brand-white',
  pending: 'bg-brand-blue-dark text-brand-white',
};

const NUMBER_CLASSES: Record<StageStatus, string> = {
  current: 'bg-brand-blue-dark text-brand-yellow',
  done: 'bg-brand-green text-brand-navy',
  pending: 'bg-white/20 text-brand-white',
};

/**
 * Estágios do reconhecimento, no cabeçalho da modal. O número e o nome são o que se vê; o
 * leitor de tela recebe a frase inteira, com o estado de cada estágio (REC-02).
 *
 * No celular os quatro nomes não cabem numa linha: só o estágio atual mostra o nome, e os
 * outros ficam no número. Da largura `sm` em diante, todos mostram o nome.
 */
export function RecognitionStepper({ step }: { step: Step }) {
  return (
    <ol aria-label="Etapas do reconhecimento" className="mt-4 flex flex-wrap gap-2">
      {STAGE_LABELS.map((label, stage) => {
        const status = stageStatus(stage, step);

        return (
          <li
            key={label}
            aria-current={status === 'current' ? 'step' : undefined}
            className={`inline-flex items-center gap-2 rounded-jj-pill py-[5px] pl-[5px] font-display text-[11.5px] font-bold ${
              status === 'current' ? 'pr-3.5' : 'pr-[5px] sm:pr-3.5'
            } ${PILL_CLASSES[status]}`}
          >
            <span className="screen-reader-text">{stageReading(stage, step)}</span>
            <span
              aria-hidden="true"
              className={`inline-flex h-[21px] w-[21px] shrink-0 items-center justify-center rounded-full text-[10.5px] ${NUMBER_CLASSES[status]}`}
            >
              {stage + 1}
            </span>
            <span aria-hidden="true" className={status === 'current' ? undefined : 'hidden sm:inline'}>
              {label}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
